import React from 'react';
import { DetailsInfoProps } from './types';
import { useParams } from 'react-router-dom';
import { MissionIdParams } from '@src/core/entities';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { ArcCellInfo, ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import { arcLatToDMS, arcLngToDMS } from '@src/core/extensions';
import { EMPTY_STRING } from '@src/core/config';

const DetailsInfo: React.FC<DetailsInfoProps> = (props) => {
  const { missionId } = useParams<MissionIdParams>();
  const { missionId: propsMissionId } = props;
  const effectiveMissionId = propsMissionId || missionId;
  
  const { data, isLoading } = useGetOrderMissionQuery(effectiveMissionId, { skip: !effectiveMissionId });

  if (isLoading) {
    return <ArcSkeleton height={250} />;
  }

  const [order] = data?.orders ?? [];

  return (
    <ArcStack p={2} borderRadius={1} spacing={2} bgcolor='background.paper'>
      <ArcStack spacing={1} direction='row' justifyContent='space-between'>
        <ArcText.h5> Details </ArcText.h5>
      </ArcStack>
      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Order' width='50%'>
        #{order?.id}
        </ArcCellInfo>
        <ArcCellInfo label='Destination' width='50%'> 
          {order?.destinationLocation?.address}
        </ArcCellInfo>
      </ArcStack>

      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Latitude' width='50%'>
          {order?.destinationLocation?.latitude != null
            ? String(Number(order.destinationLocation.latitude))
            : EMPTY_STRING}
        </ArcCellInfo>
        <ArcCellInfo label='Longitude' width='50%'>
          {order?.destinationLocation?.longitude != null
            ? String(Number(order.destinationLocation.longitude))
            : EMPTY_STRING}
        </ArcCellInfo>
      </ArcStack>

      <ArcStack direction='row' spacing={1}>
        <ArcCellInfo label='Package Content' width='50%'>
          {order?.packageContent || EMPTY_STRING}
        </ArcCellInfo>
        <ArcCellInfo label='Client Name' width='50%'> 
          {order?.clientName || EMPTY_STRING}
        </ArcCellInfo>
      </ArcStack>
    </ArcStack>
  );
};

export default DetailsInfo;